import icons from 'url:../../img/icons.svg';
class AddRecipeView {
  #parentEl = document.querySelector('.upload');
  #addRecipeBtn = document.querySelector('.nav__btn--add-recipe');
  #closeBtn = document.querySelector('.btn--close-modal');
  #addRecipeWindow = document.querySelector('.add-recipe-window');
  #overlay = document.querySelector('.overlay');
  // #uploadBtn = document.querySelector('.upload__btn');

  constructor() {
    this.#addRecipeBtnHandler();
    this.#closeBtnHandler();
    // console.log('abc');
  }

  renderSpinner() {
    const markup = `
      <div class="spinner">
        <svg>
          <use href="${icons}#icon-loader"></use>
        </svg>
      </div>
    `;
    this.#clear();
    this.#parentEl.insertAdjacentHTML('afterbegin', markup);
  }

  renderError(message) {
    const markup = `
        <div class="error">
          <div>
            <svg>
              <use href="${icons}#icon-alert-triangle"></use>
            </svg>
          </div>
          <p>${message}</p>
        </div>`;

    this.#clear();
    this.#parentEl.insertAdjacentHTML('afterbegin', markup);
  }

  #clear() {
    this.#parentEl.innerHTML = '';
  }

  toogleClassFn() {
    this.#overlay.classList.toggle('hidden');
    this.#addRecipeWindow.classList.toggle('hidden');
  }

  #addRecipeBtnHandler() {
    // console.log(this.#addRecipeBtn);
    this.#addRecipeBtn.addEventListener('click', this.toogleClassFn.bind(this));
  }

  #closeBtnHandler() {
    this.#closeBtn.addEventListener('click', this.toogleClassFn.bind(this));
    this.#overlay.addEventListener('click', this.toogleClassFn.bind(this));
  }

  adduploadHandler(handler) {
    this.#parentEl.addEventListener('submit', function (e) {
      e.preventDefault();
      const data = [...new FormData(this)];
      const uploadData = Object.fromEntries(data);
      // console.log(data);
      handler(uploadData);
    });
  }
}

export default new AddRecipeView();
